import { FontWeight } from 'lib/styles';
import { Text } from 'styles/themeColors';
import { formatDateTime } from 'utils/formatters';

// Centralized constants for the Affiliate UI.
// All affiliate strings (page titles, column headers, statuses, buttons, tabs,
// toasts) and table column definitions live in this file.

export const AFFILIATE_STRINGS = {
  pageTitles: {
    members: 'Members',
    memberDetails: 'Member Details'
  },
  tabs: {
    overview: 'Overview',
    commissionOrders: 'Commission Orders'
  },
  buttons: {
    payCommission: 'Pay Commission',
    deactivateAffiliate: 'Deactivate Affiliate',
    approveSelected: 'Approve Selected',
    unapproveSelected: 'Unapprove Selected',
    paySelected: 'Pay Selected'
  },
  labels: {
    totalCommissionEarned: 'Total Commission Earned',
    totalCommission: 'Total Commission',
    totalPaidOut: 'Total Paid Out',
    balance: 'Balance',
    selectedCount: 'selected',
    totalCommissionSelected: 'Total Commission (Selected)',
    affiliateProgramHistory: 'Affiliate Program History'
  },
  status: {
    active: 'Active',
    deactivated: 'Deactivated',
    pending: 'Pending',
    approved: 'Approved',
    paid: 'Paid'
  },
  search: {
    placeholder: 'Search'
  },
  switches: {
    complianceCheckFailed: 'Compliance check failed'
  },
  columns: {
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    companyEmail: 'Company Email',
    complianceCheck: 'Compliance check',
    country: 'Country',
    createdDate: 'Created Date',
    status: 'Status',
    companyLegalName: 'Company Legal Name',
    ofmpCompanyName: 'OFMP Company Name',
    companyNameByCustomer: 'Company name input by customer'
  }
};

export const AFFILIATE_MEMBER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const AFFILIATE_MEMBER_TABS = [
  {
    value: AFFILIATE_STRINGS.tabs.overview,
    badge: { content: '', color: '', backgroundColor: '' }
  },
  {
    value: AFFILIATE_STRINGS.tabs.commissionOrders,
    badge: { content: '', color: '', backgroundColor: '' }
  }
];

export const AFFILIATE_SETTINGS_TABS = [
  {
    value: 'Email notifications',
    badge: { content: '', color: '', backgroundColor: '' }
  }
];

const headerStyle = { color: Text.primary, fontWeight: FontWeight.bold };

export const AFFILIATE_MEMBER_COLUMNS = [
  {
    title: AFFILIATE_STRINGS.columns.customerName,
    field: 'fullName',
    headerStyle,
    width: '12%',
    removable: false
  },
  {
    title: AFFILIATE_STRINGS.columns.customerPhone,
    field: 'phone',
    headerStyle,
    width: '12%'
  },
  {
    title: AFFILIATE_STRINGS.columns.companyEmail,
    field: 'email',
    headerStyle,
    width: '14%'
  },
  {
    title: AFFILIATE_STRINGS.columns.complianceCheck,
    field: 'dowJonesStatus',
    headerStyle,
    width: '11%',
    removable: false
  },
  {
    title: AFFILIATE_STRINGS.columns.country,
    field: 'countryName',
    headerStyle,
    width: '10%'
  },
  {
    title: AFFILIATE_STRINGS.columns.createdDate,
    field: 'createdDate',
    headerStyle,
    width: '11%',
    defaultSort: 'desc'
  },
  {
    title: AFFILIATE_STRINGS.columns.status,
    field: 'status',
    headerStyle,
    width: '10%',
    removable: false
  },
  {
    title: AFFILIATE_STRINGS.columns.companyLegalName,
    field: 'companyName',
    headerStyle,
    width: '10%',
    hidden: true,
    hiddenByColumnsButton: true
  },
  {
    title: AFFILIATE_STRINGS.columns.ofmpCompanyName,
    field: 'displayName',
    headerStyle,
    width: '10%',
    hidden: true,
    hiddenByColumnsButton: true
  },
  {
    title: AFFILIATE_STRINGS.columns.companyNameByCustomer,
    field: 'companyNameByCustomer',
    headerStyle,
    width: '10%',
    hidden: true,
    hiddenByColumnsButton: true
  }
];


export const COMMISSION_TRANSACTION_TYPES = {
  ORDER: 'ORDER',
  PAYOUT: 'PAYOUT',
};

export const AFFILIATE_DOCUMENT_CATEGORIES = {
  PICKSLIP: 'Affiliate Pickslip',
  RECEIPT: 'Affiliate Receipt',
};

export const COMMISSION_ORDER_COLUMNS = [
  {
    title: 'Order ID',
    field: 'orderId',
    headerStyle,
    width: '20%'
  },
  {
    title: 'Commission Amount',
    field: 'commissionAmount',
    headerStyle,
    width: '18%',
    type: 'currency'
  },
  {
    title: 'Status',
    field: 'status',
    headerStyle,
    width: '12%'
  },
  {
    title: 'Approved Date',
    field: 'approvedDate',
    headerStyle,
    width: '15%'
  },
  {
    title: 'Paid Date',
    field: 'paidDate',
    headerStyle,
    width: '15%'
  },
  {
    title: 'Created Date',
    field: 'createdOn',
    headerStyle,
    width: '15%',
    defaultSort: 'desc'
  }
];

export const PAYMENT_HISTORY_COLUMNS = [
  {
    title: 'Payout ID',
    field: 'transactionId',
    // headerStyle.flexGrow is applied dynamically in PaymentHistory based on data length
  },
  {
    title: 'Date Paid',
    field: 'paidDate',
    render: (record) => record.paidDate ? formatDateTime(record.paidDate) : '—',
  },
  {
    title: 'Amount Paid',
    field: 'commissionAmount',
  },
];

export const AFFILIATE_QUESTIONNAIRE_CATEGORY = 'Affiliate Questionnaire';